import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    selector: 'app-search-field',
    imports: [FormsModule, IconFieldModule, InputIconModule, InputTextModule],
    template: `
        <!-- type="text", not "search": Chromium would draw a second clear button next to this one. -->
        <p-iconfield class="search-field">
            <p-inputicon class="pi pi-search" />
            <input #input pInputText type="text" class="search-field__input" autocomplete="off"
                [placeholder]="placeholder()" [attr.aria-label]="ariaLabel()" [ngModel]="value()"
                (ngModelChange)="value.set($event)" (keydown.escape)="clear()" />
            @if (value()) {
                <p-inputicon>
                    <button type="button" class="search-field__clear" aria-label="Limpar busca"
                        (click)="clear(); input.focus()">
                        <i class="pi pi-times" aria-hidden="true"></i>
                    </button>
                </p-inputicon>
            }
        </p-iconfield>
    `,
    styles: `
        :host {
            display: block;
            width: 20rem;
            max-width: 100%;
        }

        /* 100vw forces a row of its own on a phone; max-width brings it back to the toolbar's width. */
        @media (max-width: 575.98px) {
            :host {
                width: 100vw;
            }
        }

        .search-field {
            display: block;
        }

        .search-field__input {
            width: 100%;
        }

        .search-field__clear {
            display: inline-flex;
            padding: 0;
            border: 0;
            border-radius: 999px;
            background: none;
            color: inherit;
            font: inherit;
            cursor: pointer;
        }

        .search-field__clear:hover {
            color: var(--p-text-color);
        }

        .search-field__clear:focus-visible {
            outline: var(--p-focus-ring-width) var(--p-focus-ring-style) var(--p-focus-ring-color);
            outline-offset: var(--p-focus-ring-offset);
        }
    `
})
export class SearchFieldComponent {
    readonly value = model.required<string>();
    readonly placeholder = input.required<string>();
    readonly ariaLabel = input.required<string>();

    protected clear(): void {
        this.value.set('');
    }
}
